import { canNavigate, ConductorOneChildActive, Router, ScreenBase, splitUrlSegments } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import EnumService from "services/enumService";
import ExemptionViewModel, { ExemptionNoticeNavigationName } from "./exemptionViewModel";
import ExemptionDocumentsUploadedViewModel, {
  ExemptionDocumentsUploadedViewModelNavigationName,
} from "./exemptionDocumentsUploadedViewModel";
import { Notice } from "../../../services/NIA/niaService";
import NoticeEntity from "models/notice";

export const ExemptionModuleNavigationName = "exemption";

@Router.registerRoute({
  route: ExemptionModuleNavigationName,
  name: Router.Self,
  children: [ExemptionViewModel, ExemptionDocumentsUploadedViewModel],
})
export default class ExemptionNoticeViewModel extends ConductorOneChildActive<ScreenBase> {
  constructor(
    private documentsVMFactory: ReturnType<typeof ExemptionDocumentsUploadedViewModel.Factory>,
    public localizationService: LocalizationService,
    private enumService: EnumService,
    private exemptionViewModel: ExemptionViewModel
  ) {
    super();
    this.nameValue = "exemption.title";
    this.navigationName = ExemptionModuleNavigationName;
  }

  onInitialize() {
    this.enumService.initialize();
    return this.tryActivateChild(this.exemptionViewModel);
  }

  async navigate(subPath: string | undefined, params: any) {
    const segments = splitUrlSegments(subPath);
    let childToActivate;
    if (segments[0] === ExemptionDocumentsUploadedViewModelNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    } else if (segments[0] === ExemptionNoticeNavigationName) {
      childToActivate = await this.findNavigationChild(subPath || "");
    }

    if (childToActivate) {
      await this.tryActivateChild(childToActivate);

      if (canNavigate(childToActivate)) {
        await childToActivate.navigate(segments[1], params);
      }
    }

    await this.onChildNavigated(childToActivate);
  }

  async findNavigationChild(navigationName: string) {
    if (navigationName.includes(ExemptionDocumentsUploadedViewModelNavigationName)) {
      const noticeString = sessionStorage.getItem(Notice.EXEMPTION);

      if (noticeString) {
        const notice = JSON.parse(noticeString) as NoticeEntity;

        if (notice._noticeBase64) {
          return this.documentsVMFactory(notice._noticeBase64, Notice.EXEMPTION);
        }
      }
    }
    return super.findNavigationChild(navigationName);
  }
}
